export const COMMON_METRICS = {
  allMetrics: [],
  defaultUnselected: [
    'reports-impressionswebview',
    'reports-impressions',
    'workspaces-name',
    'reports-impressionsuniq',
    'reports-impressionsbot',
    'reports-visitsbot',
    'reports-costbot',
    'reports-clicksbot',
    'reports-conversionnew',
    'reports-conversionsent',
    'reports-conversionconfirm',
    'reports-conversiondecline',
    'reports-conversionconfirmrevenue',
    'reports-conversionconfirmhiddenrevenue',
    'reports-conversioncharge',
    'affiliate_networks-id',
    'affiliate_networks-appendclickid',
    'affiliate_networks-postbackonlywhiteips',
    'affiliate_networks-created',
    'affiliate_networks-updated',
    'affiliate_networks-updatedby',
    'affiliate_networks-updatedbyid',
    'traffic_sources-id',
    'traffic_sources-postbackurl',
    'traffic_sources-extclickidparam',
    'traffic_sources-costparam',
    'traffic_sources-custom1param',
    'traffic_sources-custom2param',
    'traffic_sources-custom3param',
    'traffic_sources-custom4param',
    'traffic_sources-custom5param',
    'traffic_sources-custom6param',
    'traffic_sources-custom7param',
    'traffic_sources-custom8param',
    'traffic_sources-custom9param',
    'traffic_sources-custom10param',
    'traffic_sources-created',
    'traffic_sources-updated',
    'traffic_sources-updatedby',
    'traffic_sources-updatedbyid',
    'flows-id',
    'flows-created',
    'flows-updated',
    'flows-updatedby',
    'flows-updatedbyid',
    'landings-id',
    'landings-url',
    'landings-countryid',
    'landings-offers',
    'landings-created',
    'landings-updated',
    'landings-updatedby',
    'landings-updatedbyid',
    'offers-id',
    'offers-updatedbyid',
    'offers-url',
    'offers-countryid',
    'offers-payout',
    'offers-affiliatenetworkid',
    'offers-created',
    'offers-updated',
    'offers-updatedby',
    'campaigns-id',
    'campaigns-updatedbyid',
    'campaigns-created',
    'campaigns-updated',
    'campaigns-url',
    'campaigns-externalstatus',
    'campaigns-externalid',
    'campaigns-updatedby',
    'campaigns-countryid',
    'campaigns-trafficsourceid',
    'campaigns-costmodel',
    'campaigns-costvalue',
    'reports-custom1masked',
    'reports-custom2masked',
    'reports-custom3masked',
    'reports-custom4masked',
    'reports-custom5masked',
    'reports-custom6masked',
    'reports-custom7masked',
    'reports-custom8masked',
    'reports-custom9masked',
    'reports-custom10masked',
    'reports-impressionssuspicious',
    'reports-impressionssuspiciousblacklistedips',
    'reports-impressionssuspiciousdatacenterips',
    'reports-impressions_suspicious_ip_with_frequent_events',
    'reports-impressions_suspicious_ip_with_frequent_campaign_events',
    'reports-visitssuspicious',
    'reports-visitssuspiciousblacklistedips',
    'reports-visitssuspiciousdatacenterips',
    'reports-clickssuspicious',
    'reports-clickssuspiciousblacklistedips',
    'reports-clickssuspiciousdatacenterips',
    'reports-visits_suspicious_ip_with_frequent_events',
    'reports-clicks_suspicious_ip_with_frequent_events',
    'reports-visits_suspicious_ip_with_frequent_campaign_events',
    'reports-clicks_fast_clicker',
    'reports-clicks_suspicious_ip_with_frequent_campaign_events',
    'reports-cpa',
    'reports-hiddenprofit',
    'reports-conversionchargerevenue',
    'campaigns-number',
    'landings-number',
    'offers-number',
    'flows-number',
    'affiliate_networks-number',
    'traffic_sources-number',
    'reports-conversionswebview',
    'reports-conversionswebviewrevenue',
  ],
  defaultSelected: [
    'affiliate_networks-name',
    'traffic_sources-name',
    'flows-name',
    'landings-name',
    'offers-name',
    'campaigns-name',
    'reports-browser',
    'reports-hiddenrevenue',
    'reports-month',
    'reports-conversionconfirm'
  ],
  defaultSort: [
    'reports-visits',
    'reports-profit',
    'reports-roi',
    'reports-clicks',
    'reports-conversionconfirm',
    'reports-revenue',
    'reports-hiddenrevenue',
    'reports-cost',
    'reports-costbot',
    'reports-visitsuniq',
    'reports-clicksuniq',
    'reports-impressions',
    'reports-cpv',
    'reports-cpc',
    'reports-ctr',
    'reports-ap',
    'reports-cr',
    'reports-cv',
    'reports-conversionswebview',
    'reports-conversionswebviewrevenue'
  ],
  filters: [
    'reports-impressions',
    'reports-impressionsuniq',
    'reports-impressionsbot',
    'reports-visits',
    'reports-visitsuniq',
    'reports-visitsbot',
    'reports-costbot',
    'reports-cpa',
    'reports-clicks',
    'reports-clicksuniq',
    'reports-clicksbot',
    'reports-conversionnew',
    'reports-conversionsent',
    'reports-conversionconfirm',
    'reports-conversiondecline',
    'reports-conversioncharge',
    'reports-revenue',
    'reports-hiddenrevenue',
    'reports-cost',
    'reports-profit',
    'reports-cpv',
    'reports-cpc',
    'reports-ctr',
    'reports-1xctr',
    'reports-uctr',
    'reports-cr',
    'reports-1xcr',
    'reports-cv',
    'reports-1xcv',
    'reports-roi',
    'reports-epv',
    'reports-epc',
    'reports-ap',
    'reports-conversions',
    'reports-conversionconfirmrevenue',
    'reports-conversionconfirmhiddenrevenue',
    'reports-impressionswebview',
    'reports-visitswebview',
    'reports-clickswebview',
    'reports-impressionssuspicious',
    'reports-impressionssuspiciousblacklistedips',
    'reports-impressionssuspiciousdatacenterips',
    'reports-visitssuspicious',
    'reports-visitssuspiciousblacklistedips',
    'reports-visitssuspiciousdatacenterips',
    'reports-visits_suspicious_ip_with_frequent_events',
    'reports-visits_suspicious_ip_with_frequent_campaign_events',
    'reports-clickssuspicious',
    'reports-clickssuspiciousblacklistedips',
    'reports-clickssuspiciousdatacenterips',
    'reports-clicks_fast_clicker',
    'reports-impressions_suspicious_ip_with_frequent_events',
    'reports-clicks_suspicious_ip_with_frequent_events',
    'reports-impressions_suspicious_ip_with_frequent_campaign_events',
    'reports-clicks_suspicious_ip_with_frequent_campaign_events',
    'reports-hiddenprofit',
    'reports-conversionchargerevenue',
    'reports-conversionswebview',
    'reports-conversionswebviewrevenue'
  ],

  exclude: {
    offers: [
      'offers-id',
      'offers-url',
      'offers-countryid',
      'offers-payout',
      'offers-affiliatenetworkid'
    ],
    landings: [
      'landings-id',
      'landings-url',
      'landings-countryid',
      'landings-offers'
    ],
    flows: [
      'flows-id'
    ],
    'traffic-sources': [
      'traffic_sources-id',
      'traffic_sources-postbackurl',
      'traffic_sources-extclickidparam',
      'traffic_sources-costparam',
      'traffic_sources-custom1param',
      'traffic_sources-custom2param',
      'traffic_sources-custom3param',
      'traffic_sources-custom4param',
      'traffic_sources-custom5param',
      'traffic_sources-custom6param',
      'traffic_sources-custom7param',
      'traffic_sources-custom8param',
      'traffic_sources-custom9param',
      'traffic_sources-custom10param'
    ],
    'affiliate-networks': [
      'affiliate_networks-id',
      'affiliate_networks-appendclickid',
      'affiliate_networks-postbackonlywhiteips'
    ],
    campaigns: [
      'campaigns-id',
      'campaigns-countryid',
      'campaigns-url',
      'campaigns-trafficsourceid',
      'campaigns-costmodel',
      'campaigns-costvalue',
      'campaigns-externalstatus',
      'campaigns-externalid'
    ]
  },

  weight: {},
  sort_exclude:[
    'campaigns-url'
  ]

}
